import { toast } from 'react-toastify';

// NestJS answers a rejected request with { message: string | string[], error, statusCode }.
// A 400's message names the field the user must fix; other statuses' messages are not for users.
const getValidationMessage = (error: any): string | undefined => {
  const body = error?.data ?? error;
  const status = error?.status ?? body?.statusCode;
  if (status !== 400) return undefined;
  const message = body?.message;
  if (Array.isArray(message)) return message.join('. ') || undefined;
  return typeof message === 'string' && message ? message : undefined;
};

export const errorHandler = (
  from: string,
  customError: string,
  error: any,
  showToast: boolean,
  loadingBar?: boolean
) => {
  if (process.env.NODE_ENV === 'development') {
    /* eslint-disable-next-line no-console */
    console.debug(from, error);
  }
  if (showToast) {
    const validationMessage = getValidationMessage(error);
    let text = customError;
    if (validationMessage) {
      text = /[.!?]$/.test(customError)
        ? `${customError} ${validationMessage}`
        : `${customError}: ${validationMessage}`;
    }
    toast(text, {
      type: 'error',
      hideProgressBar: loadingBar,
      // if we want to change color to match figma
      // style: { backgroundColor: 'blue' },
    });
  }
};
